import { TKImgWaitlist } from "assets/images/jpgs";
import InputField from "shared/InputField";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import TKModal from "./Modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { joinWaitlist } from "appState/auth/authSlice";
import { TKIconSpinner } from "assets/images/svgs";

const JoinWaitlistModal = ({ isOpen, onClose }) => {
  const { isLoading } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !contactNumber) {
      toast.error("Invalid email or contact number!");
      return;
    }
    if (contactNumber.length !== 13) {
      toast.error(
        "Invalid contact number length. Contact number must start with 234!"
      );
      return;
    }
    dispatch(joinWaitlist({ email, contactNumber })).then((data) => {
      if (data?.payload?.status === 201) {
        toast.success("Thank you for joining our waitlist!");
        onClose();
      }
    });
  };

  return (
    <TKModal open={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center gap-4 py-8">
        <img src={TKImgWaitlist} alt="join-waitlist" />
        <div className="w-4/5 max-md:w-full">
          <p className="text-[#7A7A7A] text-[16px] text-center">
            Happy to have you join the TK Family as an NGO or Donor. We are
            currently setting up for up a successful ride. Please leave your
            email address and contact for update as we progress
          </p>
        </div>
      </div>
      <div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <InputField
              type="email"
              label={"Email"}
              name="email"
              placeholder="info@truekeepers.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">Contact Number</label>
            <PhoneInput
              placeholder="+2349012345678"
              country={"ng"}
              onlyCountries={["ng"]}
              value={contactNumber}
              onChange={setContactNumber}
              containerClass="donorSignupPhoneInput"
              inputProps={{
                name: "mobile",
                required: true,
                autoFocus: true,
              }}
            />
          </div>
          <div className="py-4">
            <button
              type="submit"
              className="h-[55px] bg-[#213874] rounded-md text-white w-full p-2 flex justify-center items-center"
            >
              {isLoading ? <TKIconSpinner /> : "Join Waitlist"}
            </button>
          </div>
        </form>
      </div>
    </TKModal>
  );
};

export default JoinWaitlistModal;
